<!-- https://www.figma.com/file/reAk2sU4YpRajpQu2YBOHk/007%2F1.-%D0%AD%D0%BB%D0%B5%D0%BC%D0%B5%D0%BD%D1%82%D1%8B?type=design&node-id=12800-208746&mode=design&t=Di0oFX00ri6IpIr5-0 -->
<template>
  <div
    ref="buttonContainer"
    class="core-buttons"
    :class="layoutClass"
  >
    <TheContent
      v-for="item of buttonConfig.children"
      :key="item.id"
      :elem="item"
    />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import TheContent from '../../TheContent';
  import type { ButtonAttributes } from '~/types/components/CoreButtons';

  export default defineNuxtComponent({
    name: 'CoreButtons',
    components: {
      TheContent,
    },

    props: {
      elem: {
        type: Object as PropType<TContent<ButtonAttributes>>,
        required: true,
      },
    },

    computed: {
      attributes(): ButtonAttributes {
        return this.elem.attributes;
      },

      buttonConfig(): TContent {
        return this.attributes.button;
      },

      layoutClass(): string[] {
        const classNames: string[] = [];

        if (this.attributes.layout) {
          Object.values(this.attributes.layout).forEach((item) => {
            classNames.push(`core-buttons--${item}`);
          });
        }

        if (!this.buttonConfig?.attributes.href) {
          classNames.push('core-buttons--disabled');
        }

        return classNames;
      },
    },
  });
</script>

<style lang="scss" scoped>
  .wp-block-button,
  .core-buttons {
    margin: 16px 0px;
    display: flex;
    justify-content: center;
    width: 100%;

    & > * {
      margin: 0;
    }

    :deep() {
      a {
        @include normalText;

        display: block;
        position: relative;
        width: 100%;
        padding: 12px 24px;
        border-radius: 2px;

        text-align: center;
        font-weight: 700;

        color: white;
        text-decoration: none;

        transition: all 200ms;
        background: #d4d7de;

        @include tablet {
          width: fit-content;
          min-width: 256px;
        }

        &[href] {
          background: var(--main-color);

          @include hover {
            &:before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-color: rgba(0, 0, 0, 12%);
            }
          }
        }
      }
    }
  }
</style>
